import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';

const client = getTsCustomerPortalClient();

export function usePrescription({ prescriptionId }: { prescriptionId: number }) {
  return client.prescription.getPrescription.useQuery({
    queryKey: [...client.prescription.getPrescription.keys, prescriptionId],
    queryData: {
      params: {
        id: prescriptionId,
      },
    },
    enabled: !!prescriptionId,
  });
}
